/* eslint-disable no-underscore-dangle */
import { GLOBAL } from 'saddlebag-browser';
import loadComponent from 'saddlebag-componentloader';
import logger from 'saddlebag-logger';
import observer from 'saddlebag-observer';

import { namespace } from '../constants';

const $window = GLOBAL.getWindow();
const $document = GLOBAL.getDocument();

// Mocks - delete when no longer needed
$window.Skyscanner = $window.Skyscanner || {};
$window.Skyscanner.mixpanel = $window.Skyscanner.mixpanel || {};
$window.Skyscanner.mixpanel.generateCrossDomainIdentity =
  $window.Skyscanner.mixpanel.generateCrossDomainIdentity || (() => {});

const cultureSelectorVersion = $window.__internal.CultureSelectorVersion;
delete $window.__internal.CultureSelectorVersion;

let cultureSelectorLoaded = false;

const loadCultureSelector = async (version, params) => {
  const rootElem = $document.createElement('div');
  $document.body.appendChild(rootElem);
  try {
    await loadComponent('culture-selector', version, params, rootElem);
  } catch (err) {
    logger.logError({
      message: `Culture selector OC failed to load: ${err}\n${err.stack}`,
      component: namespace,
    });
  }
};

const cultureSelectorInit = () => {
  observer.subscribe('culture-selector-clicked', (context) => {
    observer.publish('request-culture-selector');
    if (!cultureSelectorLoaded) {
      cultureSelectorLoaded = true;
      loadCultureSelector(cultureSelectorVersion, {
        market: context.market,
        locale: context.locale,
        currency: context.currency,
      });
    }
  });
};

export default cultureSelectorInit;
